import { FC } from 'react'
import { Button, Stack, Typography } from '@mui/material'

type B2CRegistriesNotifyDialogProps = {
  onClose: () => void
}

export const B2CRegistryNotifyDialog: FC<B2CRegistriesNotifyDialogProps> = ({ onClose }) => {
  return (
    <Stack gap={3}>
      <Typography variant="body2">
        Заявки переданы на обработку. Через 1 минуту обновите интерфейс для актуализации статусов операций
      </Typography>

      <Button onClick={onClose} color="secondary">
        Закрыть
      </Button>
    </Stack>
  )
}
